import { BookingData, HotelBedData } from '../shared/index';
import { CoreComponentAjaxUtils, getAjaxhelper, } from '../utils/index';
import * as moment from 'moment';

/**
 * wrapper : moment.duration
 */
export function momentDuration(param: any) {
    return moment.duration(param);
}
/**
 * wrapper moment. agar tidak import moment
 * @param param 
 */
export function momentWrapper(param?: any): any {
    return moment(param);
}
export function getAcountData(id: number): Promise<BookingData.Customer> {
    return new Promise<BookingData.Customer>((accept: (n: any) => any, reject: (exc: any) => any) => {
        new CoreComponentAjaxUtils(getAjaxhelper()).getPagedDataWithPromise({
            modelName: 'Customer',
            pageSize: 1,
            page: 0,
            orders: [['createdAt', 'desc']],
            where: {
                userId: id
            }
        }).then(
            d => {
                accept(d.rows![0]);
            }).catch((exc) => { reject(exc); });
    });
}

export function getHotelDetail(id: number, lang: string): Promise<HotelBedData.Hotel> {
    return new Promise<BookingData.Customer>((accept: (n: any) => any, reject: (exc: any) => any) => {
        getAjaxhelper().post("/dynamics/hb-api-hotel-detail/hotels-detail", {
            id: id,
            lang: lang
        }).then(d => {
            accept(d);
        }).catch(exc => {
            reject(exc);
        });
    });
}

export function getJsonFromUrl(hashBased: string) {
    var query;
    if (hashBased) {
        let pos = location.href.indexOf("?");
        if (pos === -1) {
            return [];
        }
        query = location.href.substr(pos + 1);
    } else {
        query = location.search.substr(1);
    }
    var result = {};
    query.split("&").forEach(function (part: any) {
        if (!part) { return; }
        part = part.split("+").join(" "); // replace every + with space, regexp-free version
        var eq = part.indexOf("=");
        var key = eq > -1 ? part.substr(0, eq) : part;
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
        var from = key.indexOf("[");
        if (from === -1) {
            result[decodeURIComponent(key)] = val;
        } else {
            var to = key.indexOf("]", from);
            var index = decodeURIComponent(key.substring(from + 1, to));
            key = decodeURIComponent(key.substring(0, from));
            if (!result[key]) { result[key] = []; }
            if (!index) { result[key].push(val); }  else { result[key][index] = val; }
        }
    });
    return result;
}


// WEBPACK FOOTER //
// ./src/utils/campursari.ts